import { LogOut } from 'lucide-react';

type SessionReplacedNoticeProps = {
  onClose: () => void;
};

export function SessionReplacedNotice({ onClose }: SessionReplacedNoticeProps) {
  return (
    <div className="fixed inset-0 z-[100] grid place-items-center bg-slate-950/45 p-4" role="presentation">
      <section
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-replaced-title"
        aria-describedby="session-replaced-description"
        className="w-full max-w-md rounded-2xl border border-amber-300 bg-white p-6 text-center shadow-2xl"
      >
        <LogOut className="mx-auto mb-3 text-amber-600" size={34} aria-hidden="true" />
        <h2 id="session-replaced-title" className="text-lg font-bold text-slate-900">
          このセッションを終了しました
        </h2>
        <p id="session-replaced-description" className="mt-2 text-sm leading-6 text-slate-600">
          同じアカウントで別の端末またはブラウザーからサインインしました。
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 inline-flex min-h-10 items-center justify-center rounded-lg bg-amber-600 px-5 text-sm font-bold text-white hover:bg-amber-700"
        >
          閉じる
        </button>
      </section>
    </div>
  );
}
